import { useEffect, useRef } from "react";
import { Button, Card, Col, Form, Input, InputNumber, Row, Space } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { t } from "i18next";
import { useDataGrid } from "../../../core/components/data-grid/DataGridContext";

export default function AppLogFilter() {

    const { onFilterPageSort, queryModel } = useDataGrid();
    const [form] = Form.useForm();

    useEffect(() => {
        form.setFieldsValue(queryModel.filter)
    }, [queryModel.updateKey, queryModel.filter, form])

    const onFinish = async (formData) => {
        onFilterPageSort({ filter: formData })
    }

    return (
        <Card size="small" style={{ marginBottom: 16, backgroundColor: '#fdfdfd' }}>
            <Form
                form={form}
                size={'middle'}
                layout={'vertical'}
                onFinish={onFinish}
            >
                <Row gutter={[16, 16]} align="bottom">
                    <Col xs={24} sm={10} md={8} lg={6}>
                        <Form.Item
                            name={'Username'}
                            label={t('Username')}
                            style={{ marginBottom: 0 }}
                        >
                            <Input placeholder={t('Username')} allowClear />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={10} md={8} lg={6}>
                        <Form.Item
                            name={'RefTableKey'}
                            label={t('RefTableKey')}
                            style={{ marginBottom: 0 }}
                        >
                            <InputNumber placeholder={t('RefTableKey')} style={{ width: '100%' }} />
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={4} md={4} lg={4}>
                        <Form.Item style={{ marginBottom: 0 }}>
                            <Button
                                type="primary"
                                htmlType={'submit'}
                                icon={<SearchOutlined />}
                                block
                            >
                                {t('Search')}
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Card>
    )
}